import jquery from "jquery";
window.jQuery = window.$ = jquery;

// Bootstrap Framework
import "@popperjs/core";
import "bootstrap";
import Swal from 'sweetalert2';
// AdminKit core
import "./adminkit/app";

import "slick-carousel";
import hcSticky from "hc-sticky";
import AfterViewportJs from "@lysla/afterviewportjs";
import { Tooltip } from "bootstrap";
import { Fancybox } from "@fancyapps/ui";
/* import "@fancyapps/ui/dist/fancybox/fancybox.css"; */

//#region stickybar

document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector(".ticket-header");
  const side = document.querySelector(".side-ticket");
  const container = document.querySelector("#fixed-ticket-bar");
  if (!header || !side || !container) return;

  const EXTRA_GAP = 64;
  const MIN_DESKTOP = 992;

  let headerPlaceholder = null;
  let sidePlaceholder = null;
  let headerFixed = false;
  let sideFixed = false;
  let sideDocked = false;
  let containerOriginalPosition = window.getComputedStyle(container).position;

  // Metriche
  let headerHeight = 0;
  let sideHeight = 0;
  let sideWidth = 0;
  let headerInitialTop = 0;
  let containerTop = 0;
  let containerHeight = 0;
  let containerBottom = 0;

  // Utility di misura (chiama quando necessario: resize o RO)
  function measureAll() {
    const hRect = header.getBoundingClientRect();
    headerHeight = Math.ceil(hRect.height);
    const sRect = side.getBoundingClientRect();
    sideHeight = Math.ceil(sRect.height);
    sideWidth = Math.ceil(sRect.width);

    const cRect = container.getBoundingClientRect();
    containerTop = cRect.top + window.pageYOffset;
    containerHeight = Math.ceil(container.offsetHeight);
    containerBottom = containerTop + containerHeight;

    // headerInitialTop = posizione del header nel documento prima che diventi fixed.
    if (headerPlaceholder) {
      headerInitialTop = headerPlaceholder.getBoundingClientRect().top + window.pageYOffset;
    } else {
      headerInitialTop = hRect.top + window.pageYOffset;
    }
  }

  // Helpers per placeholder
  function createHeaderPlaceholder() {
    if (headerPlaceholder) return;
    headerPlaceholder = document.createElement("div");
    headerPlaceholder.style.height = headerHeight + "px";
    headerPlaceholder.className = "js--ph-header";
    header.parentNode.insertBefore(headerPlaceholder, header);
  }
  function removeHeaderPlaceholder() {
    if (!headerPlaceholder) return;
    headerPlaceholder.parentNode.removeChild(headerPlaceholder);
    headerPlaceholder = null;
  }

  function createSidePlaceholder() {
    if (sidePlaceholder) return;
    sidePlaceholder = document.createElement("div");
    sidePlaceholder.style.width = sideWidth + "px";
    sidePlaceholder.style.height = sideHeight + "px";
    sidePlaceholder.className = "js--ph-side";
    side.parentNode.insertBefore(sidePlaceholder, side);
  }
  function removeSidePlaceholder() {
    if (!sidePlaceholder) return;
    sidePlaceholder.parentNode.removeChild(sidePlaceholder);
    sidePlaceholder = null;
  }

  // Fissa header in alto (replica sticky)
  function fixHeader() {
    if (headerFixed) return;
    createHeaderPlaceholder();
    const r = header.getBoundingClientRect();
    header.style.position = "fixed";
    header.style.top = "0";
    header.style.left = r.left + "px";
    header.style.width = r.width + "px";
    header.style.zIndex = 1200;
    header.classList.add("ticket-header--sticked");
    headerFixed = true;
  }

  function unfixHeader() {
    if (!headerFixed) return;
    header.style.position = "";
    header.style.top = "";
    header.style.left = "";
    header.style.width = "";
    header.style.zIndex = "";
    header.classList.remove("ticket-header--sticked");
    removeHeaderPlaceholder();
    headerFixed = false;
  }

  // Fissa side ticket sotto header (fixed)
  function fixSide() {
    if (sideFixed) return;
    createSidePlaceholder();
    const phRect = sidePlaceholder.getBoundingClientRect();
    side.style.position = "fixed";
    side.style.top = headerHeight + EXTRA_GAP + "px";
    side.style.left = phRect.left + "px";
    side.style.width = sideWidth + "px";
    side.style.zIndex = 1100;
    sideFixed = true;
    sideDocked = false;
  }

  // Posiziona side assoluto in fondo al container (quando finisci lo scroll)
  function dockSideToContainerBottom() {
    if (sideDocked) return;
    createSidePlaceholder();
    // assicurati che il container sia positioned (per top assoluto relativo)
    if (window.getComputedStyle(container).position === "static") {
      container.style.position = "relative";
    }
    // calcola top relativo dentro il container: containerHeight - sideHeight
    side.style.position = "absolute";
    side.style.top = containerHeight - sideHeight + "px";
    // left relativo al container:
    const phRect = sidePlaceholder.getBoundingClientRect();
    const cRect = container.getBoundingClientRect();
    side.style.left = phRect.left - cRect.left + "px";
    side.style.width = sideWidth + "px";
    side.style.zIndex = 1100;
    sideDocked = true;
    sideFixed = false;
  }

  function unfixSide() {
    if (!sideFixed && !sideDocked) return;
    side.style.position = "";
    side.style.top = "";
    side.style.left = "";
    side.style.width = "";
    side.style.zIndex = "";
    removeSidePlaceholder();
    sideFixed = false;
    sideDocked = false;
    // ripristina il position origin del container se lo abbiamo toccato
    if (containerOriginalPosition === "static") {
      container.style.position = "";
    }
  }

  // Applicabilità (solo desktop)
  function shouldApply() {
    return window.innerWidth >= MIN_DESKTOP;
  }

  // Loop principale (throttled via rAF)
  let ticking = false;
  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(run);
      ticking = true;
    }
  }

  function run() {
    ticking = false;
    if (!shouldApply()) {
      // reset se siamo su mobile o se viewport piccolo
      unfixHeader();
      unfixSide();
      return;
    }

    const scrollY = window.pageYOffset;
    // Misure aggiornate solo se necessario (non troppo spesso)
    measureAll();

    // HEADER: sticky reale quando scrollY >= headerInitialTop
    if (scrollY >= headerInitialTop) {
      fixHeader();
    } else {
      unfixHeader();
    }

    // SIDE: comportamento vincolato al container
    const headerOffset = headerHeight + EXTRA_GAP;
    const maxScrollY = containerBottom - sideHeight - headerOffset; // ultimo scrollY prima di "arrivare al fondo"
    if (scrollY >= headerInitialTop && scrollY <= maxScrollY) {
      fixSide();
      // aggiorna posizioni nel caso cambino dimensioni
      if (sidePlaceholder) {
        side.style.left = sidePlaceholder.getBoundingClientRect().left + "px";
        side.style.top = headerOffset + "px";
      }
    } else if (scrollY > maxScrollY) {
      dockSideToContainerBottom();
    } else {
      unfixSide();
    }
  }

  // Misura iniziale e listeners
  measureAll();
  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", () => {
    measureAll();
    run();
  });

  // Se header/container/side cambiano dimensione dinamicamente, ricalcola
  const ro = new ResizeObserver(() => {
    measureAll();
    run();
  });
  ro.observe(header);
  ro.observe(container);
  ro.observe(side);

  // chiamata iniziale (gestisce caso pagina già scrollata)
  run();
});

//#endregion
//#region slider
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector(".slider-alert");
  const track = slider.querySelector(".slider-alert__track");
  const alerts = Array.from(track.querySelectorAll(".alert"));
  const dotsContainer = slider.querySelector(".slider-alert__dots");

  let currentIndex = 0;

  // crea i dots
  alerts.forEach((_, i) => {
    const dot = document.createElement("div");
    dot.classList.add("dot");
    if (i === 0) dot.classList.add("active");
    dot.addEventListener("click", () => goToSlide(i));
    dotsContainer.appendChild(dot);
  });

  const dots = dotsContainer.querySelectorAll(".dot");

  function updateDots() {
    dots.forEach((d, i) => d.classList.toggle("active", i === currentIndex));
  }

  function goToSlide(index) {
    if (index < 0 || index >= alerts.length) return;
    currentIndex = index;
    track.style.transform = `translateX(-${100 * currentIndex}%)`;
    updateDots();
  }

  // swipe/drag
  let startX = 0;
  let isDragging = false;

  track.addEventListener("mousedown", startDrag);
  track.addEventListener("touchstart", startDrag);

  function startDrag(e) {
    startX = e.touches ? e.touches[0].clientX : e.clientX;
    isDragging = true;
  }

  track.addEventListener("mouseup", endDrag);
  track.addEventListener("mouseleave", endDrag);
  track.addEventListener("touchend", endDrag);

  function endDrag(e) {
    if (!isDragging) return;
    const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
    const diff = endX - startX;
    if (diff > 50) {
      goToSlide(currentIndex - 1);
    } else if (diff < -50) {
      goToSlide(currentIndex + 1);
    }
    isDragging = false;
  }

  // chiusura alert
  alerts.forEach((alertEl, i) => {
    const closeBtn = alertEl.querySelector(".close-alert");
    if (closeBtn) {
      closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        alertEl.classList.add("discarding");
        setTimeout(() => {
          alertEl.remove();
          alerts.splice(i, 1);
          dots[i].remove();
          if (currentIndex >= alerts.length) {
            currentIndex = alerts.length - 1;
          }
          goToSlide(currentIndex);
        }, 500);
      });
    }
  });

});
//#endregion

//#region form calendario
//click su icona
document.addEventListener("DOMContentLoaded", () => {
  const calendarIconDa = document.getElementById("calendarIconDa");
  const dateInputDa = document.getElementById("dateInputDa");

  const calendarIconA = document.getElementById("calendarIconA");
  const dateInputA = document.getElementById("dateInputA");

  if (calendarIconDa && dateInputDa) {
    calendarIconDa.addEventListener("click", () => {
      try {
        dateInputDa.showPicker();
      } catch (err) {
        dateInputDa.click();
      }
    });
  }

  if (calendarIconA && dateInputA) {
    calendarIconA.addEventListener("click", () => {
      try {
        dateInputA.showPicker();
      } catch (err) {
        dateInputA.click();
      }
    });
  }
});
//placeholder
document.querySelectorAll('input[type="date"]').forEach((input) => {
  const label = input.nextElementSibling;

  const togglePlaceholder = () => {
    if (input.value) {
      label.style.opacity = 0;
      input.style.color = "black";
      input.style.caretColor = "auto";
    } else {
      label.style.opacity = 1;
      input.style.color = "transparent";
      input.style.caretColor = "transparent";
    }
  };

  input.addEventListener("change", togglePlaceholder);
  input.addEventListener("input", togglePlaceholder);

  togglePlaceholder();
});
//#endregion
document.addEventListener("DOMContentLoaded", function () {
    const loader = document.getElementById("page-loader");

    // intercetta il submit di tutte le form che contengono un bottone con classe .has-loader
    document.querySelectorAll("form").forEach(function (form) {
        const hasLoaderButton = form.querySelector(".has-loader");
        if (!hasLoaderButton) return; // ignora form senza loader

        form.addEventListener("submit", function (event) {
            if (!form.checkValidity()) {
                // blocca l'invio e mostra messaggi di errore nativi
                event.preventDefault();
                event.stopPropagation();
                form.reportValidity();
                return false;
            }

            // se è valida, mostra il loader con effetto fade-in
            loader.style.display = "flex";
            void loader.offsetWidth; // forza repaint per la transizione
            loader.classList.add("show");
        });
    });
});

//#region form + dropzone

(() => {
  // ==============================
  // Config minimi
  // ==============================
  const MISSING = ""; // campo vuoto se mancante
  const ROUTES = {
    "step-1": { next: "new-ticket-step-2.html" },
    "step-2": { prev: "new-ticket.html", next: "new-ticket-step-3.html" },
    "step-3": { prev: "new-ticket-step-2.html", next: "new-ticket-step-4.html" },
  };
  const STORAGE_KEY = "ticketData";

  // ==============================
  // Utils storage
  // ==============================
  const loadData = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "{}");
    } catch {
      return {};
    }
  };
  const saveData = (patch) => {
    const cur = loadData();
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ ...cur, ...patch }));
  };

  // ==============================
  // Prefill dei form (step 1-3)
  // ==============================
  function prefillForm(form) {
    const data = loadData();
    if (!form) return;
    const fields = form.querySelectorAll("input, select, textarea");
    fields.forEach((el) => {
      const id = el.id;
      const name = el.name;
      if (el.type === "radio") {
        if (data[name] && el.value === data[name]) el.checked = true;
      } else if (id && data[id] != null) {
        if (el.type === "file") {
          // NON è permesso settare un valore su input[type=file].
          // Invece puoi solo ricostruire l'UI a parte (come già fai in step 2).
          return;
        }
        el.value = data[id];
      }
    });
  }
  // ==============================
  // Persistenza generica dei form
  // ==============================
  function collectAndSave(form) {
    const out = {};
    const radiosSeen = new Set();
    const fields = form.querySelectorAll("input, select, textarea");
    fields.forEach((el) => {
      if (el.type === "radio") {
        const name = el.name;
        if (!radiosSeen.has(name)) {
          const checked = form.querySelector(`input[type="radio"][name="${CSS.escape(name)}"]:checked`);
          if (checked) out[name] = checked.value;
          radiosSeen.add(name);
        }
      } else if (el.id) {
        out[el.id] = el.value.trim();
      }
    });
    saveData(out);
  }

  // ==============================
  // Validazione radio group custom (Bootstrap-friendly)
  // ==============================
  function validateRadioGroups(form) {
    const groups = form.querySelectorAll('[role="radiogroup"]');
    let allOK = true;
    groups.forEach((group) => {
      const inputs = group.querySelectorAll('input[type="radio"]');
      const invalidFb = group.querySelector(".invalid-feedback");
      const anyChecked = Array.from(inputs).some((i) => i.checked);
      if (!anyChecked) {
        inputs.forEach((i) => i.classList.add("is-invalid"));
        if (invalidFb) invalidFb.classList.add("d-block");
        allOK = false;
      } else {
        inputs.forEach((i) => i.classList.remove("is-invalid"));
        if (invalidFb) invalidFb.classList.remove("d-block");
      }
    });
    return allOK;
  }
  function wireRadioGroupLiveValidation(form) {
    form.querySelectorAll('[role="radiogroup"] input[type="radio"]').forEach((r) => {
      r.addEventListener("change", () => {
        const group = r.closest('[role="radiogroup"]');
        if (!group) return;
        const invalidFb = group.querySelector(".invalid-feedback");
        group.querySelectorAll('input[type="radio"]').forEach((i) => i.classList.remove("is-invalid"));
        if (invalidFb) invalidFb.classList.remove("d-block");
      });
    });
    }
    // validazione live sui campi
    $("#mainForm").on("input change blur", "input, select, textarea", function () {
        if (this.checkValidity()) {
            $(this).removeClass("is-invalid");
        } else {
            $(this).addClass("is-invalid");
        }
    });

  // ==============================
  // STEP 1
  // ==============================
  (function step1() {
    const form = document.getElementById("step-1");
    if (!form) return;
    prefillForm(form);
    wireRadioGroupLiveValidation(form);

    form.addEventListener("submit", (e) => {
      if (!form.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add("was-validated");
        return;
      }
      e.preventDefault();
      collectAndSave(form);
      location.href = ROUTES["step-1"].next;
    });
  })();

  // ==============================
  // DROPZONE (STEP 2)
  // ==============================
  (function dropzonesStep2() {
    const form = document.getElementById("mainForm");
    if (!form) return;

    prefillForm(form);
    wireRadioGroupLiveValidation(form);

    // Ricostruisci lista file mostrata se si torna indietro
    const data = loadData();
    for (let i = 1; i <= 5; i++) {
      const name = data[`ticketAttachments${i}`];
      const col = document.getElementById(`ticketAttachments${i}`)?.closest(".col-md-6");
      if (name && col) {
        const list = col.querySelector(".file-list");
        const clear = col.querySelector(".dz-clear");
        list.innerHTML = `<li>${name}</li>`;
        clear?.classList?.remove("d-none");
      }
    }

    // Validazione peso totale -> 250 MB fissi
    const MAX_TOTAL_MB = 250;
    const MAX_TOTAL_BYTES = MAX_TOTAL_MB * 1024 * 1024;

    const totalBytes = (excludeInput = null) => {
      let total = 0;
      document.querySelectorAll(".dz-input").forEach((inp) => {
        if (inp !== excludeInput && inp.files && inp.files.length) total += inp.files[0].size;
      });
      return total;
    };
    const humanMB = (bytes) => (bytes / 1024 / 1024).toFixed(1);

    function initSlot(col) {
      const dz = col.querySelector(".dropzone");
      const pick = col.querySelector(".dz-pick");
      const input = col.querySelector(".dz-input");
      const clear = col.querySelector(".dz-clear");
      const list = col.querySelector(".file-list");
      const invalidFb = col.querySelector(".invalid-feedback");
      const validFb = col.querySelector(".valid-feedback");

      function resetFeedback() {
        input.classList.remove("is-invalid", "is-valid");
        if (invalidFb) invalidFb.textContent = "";
        if (validFb) validFb.textContent = "";
      }
      function clearSlot() {
        const idx = input.id.replace("ticketAttachments", "");
        saveData({ [`ticketAttachments${idx}`]: "" });
        input.value = "";
        list.innerHTML = "";
        clear.classList.add("d-none");
        resetFeedback();
      }
      function handleFiles(files) {
        resetFeedback();
        if (!files || !files.length) return;
        const file = files[0];
        const prospectiveTotal = totalBytes(input) + file.size;
        if (prospectiveTotal > MAX_TOTAL_BYTES) {
          input.classList.add("is-invalid");
          if (invalidFb) invalidFb.textContent = `Peso totale ${humanMB(prospectiveTotal)} MB. Limite ${MAX_TOTAL_MB} MB.`;
          input.value = "";
          return;
        }
        // ok
        const idx = input.id.replace("ticketAttachments", "");
        saveData({ [`ticketAttachments${idx}`]: file.name });
        list.innerHTML = `<li>${file.name} (${humanMB(file.size)} MB)</li>`;
        clear.classList.remove("d-none");
        input.classList.add("is-valid");
        if (validFb) validFb.textContent = `Total: ${humanMB(prospectiveTotal)} MB / ${MAX_TOTAL_MB} MB`;
      }

      dz.addEventListener("click", () => input.click());
      pick.addEventListener("click", () => input.click());
      dz.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          input.click();
        }
      });

      input.addEventListener("change", (e) => handleFiles(e.target.files));

      ["dragenter", "dragover"].forEach((evt) => {
        dz.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
          dz.classList.add("dragover");
        });
      });
      ["dragleave", "drop"].forEach((evt) => {
        dz.addEventListener(evt, (e) => {
          e.preventDefault();
          e.stopPropagation();
          dz.classList.remove("dragover");
        });
      });
      dz.addEventListener("drop", (e) => {
        if (e.dataTransfer?.files?.length) {
          input.files = e.dataTransfer.files;
          handleFiles(input.files);
        }
      });

      clear.addEventListener("click", clearSlot);
    }

    document.querySelectorAll("#attachments-section .col-md-6").forEach(initSlot);

    // Submit step 2
    form.addEventListener("submit", (e) => {
      if (!form.checkValidity()) {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add("was-validated");
        return;
      }
      const tot = totalBytes();
      if (tot > MAX_TOTAL_BYTES) {
        e.preventDefault();
        const first = Array.from(document.querySelectorAll(".dz-input")).find((inp) => inp.files.length);
        if (first) {
          const col = first.closest(".col-md-6");
          const invalidFb = col.querySelector(".invalid-feedback");
          first.classList.add("is-invalid");
          if (invalidFb) invalidFb.textContent = `Peso totale ${humanMB(tot)} MB. Limite ${MAX_TOTAL_MB} MB.`;
        }
        form.classList.add("was-validated");
        return;
      }
      e.preventDefault();
      collectAndSave(form);
    });

  })();

  // ==============================
  // STEP 3
  // ==============================
  (function step3() {
      const form = document.getElementById("mainForm");
    if (!form) return;

    prefillForm(form);
    wireRadioGroupLiveValidation(form);

    form.addEventListener("submit", (e) => {
      const radiosOK = validateRadioGroups(form);
      if (!form.checkValidity() || !radiosOK) {
        e.preventDefault();
        e.stopPropagation();
        form.classList.add("was-validated");
        return;
      }
      e.preventDefault();
      collectAndSave(form);
      
    });

  })();

  // ==============================
  // STEP 4 (riepilogo + privacy + submit -> thankyou)
  // ==============================
  (function step4() {
    const data = loadData();

    // Helper valore o vuoto
    const val = (k) => {
      const v = data[k];
      return v && String(v).trim() ? v : MISSING;
    };

    // Sostituzione dei token nel riepilogo (senza ticketGaranzia)
    const TOKENS = [
      "ticketName",
      "ticketRole",
      "ticketEmail",
      "ticketTel",
      "ticketRagioneSociale",
      "ticketCommessa",
      "ticketAddress",
      "ticketCity",
      "ticketState",
      "ticketMachineType",
      "ticketSerialNumber",
      "ticketInstallationYear",
      "ticketTitle",
      "ticketRequestType",
      "ticketDescription",
      "ticketAttachments1",
      "ticketAttachments2",
      "ticketAttachments3",
      "ticketAttachments4",
      "ticketAttachments5",
      "ticketImpiantoFermo",
      "ticketProduzioneCompromessa",
      "ticketUrgenza",
      "ticketSupporto",
      "ticketAssistenza", // <-- garanzia rimosso
    ];

    const containers = document.querySelectorAll(".ls-wide, .form-title ~ .ls-wide, .ls-wide.mb-4, .col-xl-7, body");
    containers.forEach((el) => {
      let html = el.innerHTML,
        touched = false;

      // 1) Rimuovi la sezione "L’attività è in garanzia? ... ticketGaranzia /"
      html = html.replace(/(?:\s*\/?\s*)?<span[^>]*>\s*L[’']attivit[àa]\s*è\s*in\s*garanzia\?\s*<\/span>\s*#?ticketGaranzia\s*\/?\s*/i, "");

      // 2) Sostituzione standard token noti
      TOKENS.forEach((k) => {
        const reHash = new RegExp(`#${k}\\b`, "g");
        const reBare = new RegExp(`\\b${k}\\b`, "g");
        if (reHash.test(html) || reBare.test(html)) {
          html = html.replace(reHash, val(k)).replace(reBare, val(k));
          touched = true;
        }
      });

      if (touched) el.innerHTML = html;
    });

    // mailto
    document.querySelectorAll('a[href^="mailto:"]').forEach((a) => {
      const email = data.ticketEmail && String(data.ticketEmail).trim();
      a.href = email ? `mailto:${email}` : "#";
    });

    // Privacy + invio
    const form = document.getElementById("mainForm"); // se presente
    const privacy = document.getElementById("privacy");
    const submitBtn = document.querySelector('button[type="submit"]');

    // se manca invalid-feedback, lo creo
    let privacyFb = privacy?.closest(".form-check")?.querySelector(".invalid-feedback");
    if (privacy && !privacyFb) {
      privacyFb = document.createElement("div");
      privacyFb.className = "invalid-feedback";
      privacyFb.textContent = "You must agree to the Privacy Policy";
      privacy.closest(".form-check").appendChild(privacyFb);
    }
    function clearPrivacyError() {
      privacy?.classList.remove("is-invalid");
    }
    function showPrivacyError() {
      if (!privacy) return;
      privacy.classList.add("is-invalid");
      privacy.focus({ preventScroll: false });
    }
    privacy?.addEventListener("change", () => {
      if (privacy.checked) clearPrivacyError();
    });

    if (form) {
      form.addEventListener("submit", (e) => {
        if (privacy && !privacy.checked) {
          e.preventDefault();
          e.stopPropagation();
          showPrivacyError();
          return;
        }
      });
    }
  })();

  // ==============================
  // THANKYOU (stampa data/ora + mapping urgenza)
  // ==============================
  (function thankyou() {
    if (!location.pathname.endsWith("thankyou.html")) return;
    const data = loadData();

    // formato: 22 giu 2025, ore: 23:45
    const dt = data.ticketSubmittedAt ? new Date(data.ticketSubmittedAt) : new Date();
    const dateStr = dt.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" }).replace(/\./g, "");
    const timeStr = dt.toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit", hour12: false });
    const stamp = `${dateStr}, ore: ${timeStr}`;

    // sostituisci "DATA, ORA"
    const row = Array.from(document.querySelectorAll(".ls-wide")).find((el) => /Data di inserimento/i.test(el.textContent));
    if (row) row.innerHTML = row.innerHTML.replace(/DATA,\s*ORA/i, stamp);

    // mapping urgenza
    const urgMap = {
      low: "LOW",
      medium: "MID",
      high: "HIGH",
      "total shutdown": "MAX",
    };
    const urgRaw = (data.ticketUrgenza || "").toString().trim().toLowerCase();
    const urgVal = urgMap[urgRaw] || MISSING;

    // sostituisci token minimi della thankyou
    const TOKENS = ["ticketRequestType", "ticketEmail"];
    const containers = document.querySelectorAll(".ls-wide, .ls-wide.mb-4, body");
    containers.forEach((el) => {
      let html = el.innerHTML;
      let touched = false;
      // urgenza speciale
      if (/#ticketUrgenza\b/.test(html)) {
        html = html.replace(/#ticketUrgenza\b/g, urgVal);
        touched = true;
      }
      // altri
      TOKENS.forEach((k) => {
        const v = data[k] && String(data[k]).trim() ? data[k] : MISSING;
        const re = new RegExp(`#${k}\\b`, "g");
        if (re.test(html)) {
          html = html.replace(re, v);
          touched = true;
        }
      });
      if (touched) el.innerHTML = html;
    });

    // sistema mailto
    document.querySelectorAll('a[href^="mailto:"]').forEach((a) => {
      const email = data.ticketEmail && String(data.ticketEmail).trim();
      a.href = email ? `mailto:${email}` : "#";
      if (/#ticketEmail\b/.test(a.textContent)) a.textContent = email || MISSING;
    });
  })();
})();
//#endregion

//#region sorting table
document.addEventListener("DOMContentLoaded", () => {
  const STATUS_RANK = {
    attesa: 0,
    lavorazione: 1,
    completato: 2,
    chiuso: 3,
  };

  document.addEventListener("click", function (e) {
    const link = e.target.closest("a.sort");
    if (!link) return;

    e.preventDefault();

    const th = link.closest("th");
    if (!th) return;

    const table = th.closest("table");
    if (!table) return;

    const theadRow = th.parentNode;
    const colIndex = Array.from(theadRow.children).indexOf(th);

    const ascending = link.classList.contains("sort--up");

    sortTable(table, colIndex, ascending, STATUS_RANK);
    setActiveSortUI(th, ascending);
  });

  function setActiveSortUI(activeTh, ascending) {
    const thead = activeTh.closest("thead");
    thead.querySelectorAll("th").forEach((th) => {
      th.classList.remove("is-sorted-asc", "is-sorted-desc");
      th.removeAttribute("aria-sort");
    });
    activeTh.classList.add(ascending ? "is-sorted-asc" : "is-sorted-desc");
    activeTh.setAttribute("aria-sort", ascending ? "ascending" : "descending");
  }

  function sortTable(table, colIndex, ascending, STATUS_RANK) {
    const tbody = table.querySelector("tbody");
    const rows = Array.from(tbody.querySelectorAll("tr"));

    const decorated = rows.map((row, idx) => ({
      row,
      idx,
      key: cellSortKey(row.children[colIndex], STATUS_RANK),
    }));

    decorated.sort((a, b) => {
      const res = compareValues(a.key, b.key);
      if (res === 0) return a.idx - b.idx;
      return ascending ? res : -res;
    });

    decorated.forEach(({ row }) => tbody.appendChild(row));
  }

  function cellSortKey(td, STATUS_RANK) {
    const timeEl = td.querySelector("time[datetime]");
    if (timeEl) {
      const t = Date.parse(timeEl.getAttribute("datetime"));
      if (!Number.isNaN(t)) return { type: "number", value: t };
    }

    const statusEl = td.querySelector("[data-status]");
    if (statusEl) {
      const raw = String(statusEl.getAttribute("data-status") || "")
        .trim()
        .toLowerCase();
      const rank = STATUS_RANK.hasOwnProperty(raw) ? STATUS_RANK[raw] : Number.MAX_SAFE_INTEGER;
      return { type: "number", value: rank };
    }

    const rawText = td.textContent.trim();
    const num = parseFloat(rawText.replace(/\s/g, "").replace(",", "."));
    if (!Number.isNaN(num) && /^-?\d+([.,]\d+)?$/.test(rawText.replace(/\s/g, ""))) {
      return { type: "number", value: num };
    }

    return { type: "string", value: rawText.toLowerCase() };
  }

  function compareValues(a, b) {
    if (a.type !== b.type) {
      if (a.type === "number") return -1;
      if (b.type === "number") return 1;
    }
    if (a.type === "number" && b.type === "number") {
      return a.value - b.value;
    }
    return a.value.localeCompare(b.value);
  }
});
//#endregion
//#region tooltips
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach((el) => {
    new Tooltip(el, { container: "body" });
  });
});
//#endregion
//#region file upload chat
(function () {
  const MIME_OK = new Set(["image/jpeg", "image/png", "application/pdf"]);
  const EXT_OK = new Set(["jpg", "jpeg", "png", "pdf"]);

  function bytesFromMB(mb) {
    return Math.floor(mb * 1024 * 1024);
  }

  function ensureErrorNode(link) {
    let err = link.nextElementSibling;
    if (!err || !err.classList.contains("file-upload-chat__error")) {
      err = document.createElement("div");
      err.className = "file-upload-chat__error";
      err.setAttribute("role", "alert");
      err.setAttribute("aria-live", "polite");
      err.classList.add("text-primary");
      link.insertAdjacentElement("afterend", err);
    }
    return err;
  }

  function clearError(link) {
    const err = link.nextElementSibling;
    if (err && err.classList.contains("file-upload-chat__error")) {
      err.textContent = "";
    }
  }

  function showError(link, msg) {
    const err = ensureErrorNode(link);
    err.textContent = msg;
  }

  function validateFiles(link, fileList) {
    const maxMB = parseInt(link.dataset.maxSize || "20", 10);
    const MAX = bytesFromMB(maxMB);

    const bad = [];
    for (const f of fileList) {
      const ext = (f.name.split(".").pop() || "").toLowerCase();
      const typeOK = MIME_OK.has(f.type) || EXT_OK.has(ext);
      const sizeOK = f.size <= MAX;

      if (!typeOK || !sizeOK) {
        const problems = [];
        if (!typeOK) problems.push("tipo non ammesso");
        if (!sizeOK) problems.push(`supera ${maxMB} MB`);
        bad.push(`• ${f.name} (${problems.join(", ")})`);
      }
    }

    if (bad.length) {
      showError(link, `File non validi:\n${bad.join("\n")}\nSono ammessi: JPG, JPEG, PNG, PDF. Max ${maxMB} MB per file.`);
      return false;
    }

    clearError(link);
    return true;
  }

  function initUploadLink(link) {
    const form = link.closest("form") || link.parentElement;
    let input = form.querySelector(".file-upload-chat__input");

    if (!input) {
      input = document.createElement("input");
      input.type = "file";
      input.className = "file-upload-chat__input visually-hidden";
      form.appendChild(input);
    }

    const acceptAttr = link.dataset.accept || ".jpg,.jpeg,.png,.pdf";
    input.setAttribute("accept", acceptAttr);

    if ((link.dataset.multiple || "").toLowerCase() === "true") {
      input.setAttribute("multiple", "multiple");
    } else {
      input.removeAttribute("multiple");
    }

    link.setAttribute("role", "button");
    link.setAttribute("tabindex", "0");

    const openPicker = () => input.click();

    link.addEventListener("click", (e) => {
      e.preventDefault();
      openPicker();
    });

    link.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        openPicker();
      }
    });

    input.addEventListener("change", () => {
      const files = input.files || [];
      if (!files.length) return;

      if (!validateFiles(link, files)) {
        input.value = "";
        return;
      }

      const span = link.querySelector("span");
      if (span) {
        const names = Array.from(files).map((f) => f.name);
        span.textContent = names.join(", ");
      }
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".file-upload-chat").forEach(initUploadLink);
  });
})();
//#endregion
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".close-alert").forEach(btn => {
        btn.addEventListener("click", async (e) => {
            e.preventDefault();

            const id = btn.dataset.notificationId;
            if (!id) return;

            try {
                const response = await fetch(`/api/Ticket/NotificationRead?notificationId=${encodeURIComponent(id)}`);
                if (!response.ok) throw new Error(`Errore HTTP: ${response.status}`);

                const result = await response.json();
                console.log("Notifica segnata come letta:", result);
            } catch (err) {
                console.error("Errore durante la chiamata all'API:", err);
            }
        });
    });
});

// RESET FORM
//document.addEventListener('DOMContentLoaded', function () {
//    const resetBtn = document.getElementById('resetBtn');
//    resetBtn.addEventListener('click', function (e) {
//        e.preventDefault(); // evita submit accidentale
//        const form = this.closest('form');
//        if (!form) return;
//        form.reset();
//        form.querySelectorAll('select').forEach(s => s.value = '');
//        form.querySelectorAll('textarea').forEach(t => t.value = '');
//        form.querySelectorAll('input').forEach(t => t.value = '');
//        form.querySelectorAll('input[type="file"]').forEach(f => f.value = null);
//        form.submit();
//    });
//});
//#region chat
(() => {
  const esc = (s) => String(s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
  const nl2br = (s) => esc(s).replace(/\r?\n/g, "<br>");

  function formatDateIt(d = new Date()) {
    const date = new Intl.DateTimeFormat("it-IT", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(d);
    const time = new Intl.DateTimeFormat("it-IT", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).format(d);
    return `${date} - ${time}`;
  }

  function resolveSenderName(role, inputBox, chatContainer) {
    const dataKey = inputBox.dataset.senderName || chatContainer.dataset.senderName;
    if (dataKey) return dataKey;

    const selectorByRole = role === "CLIENTE" ? ".chat--user--output .fw-bold" : ".chat--assistance--output .fw-bold";

    const lastName = chatContainer.querySelector(`${selectorByRole}:last-of-type`);
    if (lastName && lastName.textContent.trim()) return lastName.textContent.trim();

    return role === "CLIENTE" ? "Nomeutente" : "Referente Nome Cognome";
  }

  function resolveAvatarSrc(inputBox) {
    const img = inputBox.querySelector(".col-md-auto img");
    return img ? img.getAttribute("src") : "";
  }

  function buildUserRow({ avatar, name, html, datetime }) {
    const tpl = document.createElement("template");
    tpl.innerHTML = `
      <div class="row chat chat--user chat--user--output [ g-3 mb-6 ] [ justify-content-start ] animate-fade-in" aria-live="polite">
        <div class="col-md-auto">
          <img src="${esc(avatar)}" width="50" height="50" alt="${esc(name)}" class="img-fluid">
        </div>
        <div class="col-md-7">
          <div class="chat__content">
            <p class="mb-5">${html}</p>
            <div class="d-flex align-items-center [ fs-tip-small ]">
              <span class="fw-bold text-primary [ me-2 ]">${esc(name)}</span>
              <span class="dark">${esc(datetime)}</span>
            </div>
          </div>
        </div>
      </div>
    `.trim();
    return tpl.content.firstElementChild;
  }

  function buildAssistanceRow({ avatar, name, html, datetime }) {
    const tpl = document.createElement("template");
    tpl.innerHTML = `
      <div class="row chat chat--assistance chat--assistance--output [ g-3 mb-6 ] [ justify-content-end ] animate-fade-in" aria-live="polite">
        <div class="col-md-auto [ order-1 order-md-2 ]">
          <img src="${esc(avatar)}" width="50" height="50" alt="${esc(name)}" class="img-fluid">
        </div>
        <div class="col-md-7 [ order-2 order-md-1 ]">
          <div class="chat__content">
            <p class="mb-5">${html}</p>
            <div class="d-flex align-items-center [ fs-tip-small ]">
              <span class="fw-bold text-primary [ me-2 ]">${esc(name)}</span>
              <span class="dark">${esc(datetime)}</span>
            </div>
          </div>
        </div>
      </div>
    `.trim();
    return tpl.content.firstElementChild;
  }

  function findChatContainer(inputBox) {
    let c = inputBox.previousElementSibling;
    if (!c || !c.classList || !c.classList.contains("chat-container")) {
      const isUser = inputBox.classList.contains("chat-input-container--user");
      c = document.querySelector(isUser ? ".chat-container--user" : ".chat-container--assistance");
    }
    return c;
  }

  function appendMessage({ role, inputBox, text }) {
    const chatContainer = findChatContainer(inputBox);
    if (!chatContainer) return;

    const name = resolveSenderName(role, inputBox, chatContainer);
    const avatar = resolveAvatarSrc(inputBox);
    const datetime = formatDateIt();
    const html = nl2br(text);

    const row = role === "CLIENTE" ? buildUserRow({ avatar, name, html, datetime }) : buildAssistanceRow({ avatar, name, html, datetime });

    chatContainer.appendChild(row);

    row.scrollIntoView({ behavior: "smooth", block: "end" });

    row.addEventListener("animationend", () => row.classList.remove("animate-fade-in"), { once: true });
  }

  function markInvalid(textarea, on) {
    if (!textarea) return;
    textarea.classList.toggle("is-invalid", !!on);
  }

  document.addEventListener(
    "submit",
    (evt) => {
      const form = evt.target.closest(".chat-input-container--user form, .chat-input-container--assistance form");
      if (!form) return;
      //evt.preventDefault();

      const inputBox = form.closest(".chat-input-container--user, .chat-input-container--assistance");
      const role = inputBox.classList.contains("chat-input-container--user") ? "CLIENTE" : "assistance";
      const textarea = form.querySelector("textarea");
      const value = (textarea?.value || "").trim();

      if (!value) {
        markInvalid(textarea, true);
        textarea?.focus();
        return;
      }

      appendMessage({ role, inputBox, text: value });
      if (textarea) {
        //textarea.value = "";
        markInvalid(textarea, false);
      }
    },
    true
  );
  document.addEventListener("input", (evt) => {
    if (evt.target.matches(".chat-input-container--user textarea, .chat-input-container--assistance textarea")) {
      markInvalid(evt.target, false);
    }
  });
})();
//#endregion
//#region gallery
Fancybox.bind('[data-fancybox="gallery-customer"]', {});
Fancybox.bind('[data-fancybox="gallery-assistance"]', {});
//#endregion
//#region nome file su download pdf
(() => {
  const DEFAULT_MAX = 20;
  const ELLIPSIS = "...";

  const ready = (fn) => {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", () => fn(), { once: true });
  };

  const getTrimLen = (el) => {
    const n = parseInt(el?.dataset?.trimLen || DEFAULT_MAX, 10);
    return Number.isFinite(n) && n > 0 ? n : DEFAULT_MAX;
  };

  const getFileNameFromLink = (a) => {
    const dl = a.getAttribute("download");
    if (dl && dl.trim()) return dl.trim();

    const href = a.getAttribute("href") || "";
    try {
      const url = new URL(href, document.baseURI);
      const last = url.pathname.split("/").pop() || "";
      return decodeURIComponent(last);
    } catch {
      return decodeURIComponent(href.split("#")[0].split("?")[0].split("/").pop() || "");
    }
  };

  const formatDisplayName = (filename, maxBaseLen) => {
    const dot = filename.lastIndexOf(".");
    let base = filename;
    let ext = "";

    if (dot > 0 && dot < filename.length - 1) {
      base = filename.slice(0, dot);
      ext = filename.slice(dot + 1).toLowerCase();
    }

    if (base.length > maxBaseLen) {
      return ext ? base.slice(0, maxBaseLen) + ELLIPSIS + ext : base.slice(0, maxBaseLen) + ELLIPSIS;
    }
    return ext ? `${base}.${ext}` : base;
  };

  const updateAttachment = (container) => {
    if (!container || container.nodeType !== 1) return;

    const link = container.querySelector("a[download], a[href]");
    const label = container.querySelector(".attachement__preview span");
    if (!link || !label) return;

    const max = getTrimLen(container);
    const realName = getFileNameFromLink(link);
    if (!realName) return;

    label.textContent = formatDisplayName(realName, max);
  };

  const updateAll = (root) => {
    const scope = root === document || (root && root.nodeType === 1) ? root : document;
    scope.querySelectorAll(".attachement").forEach(updateAttachment);
  };

  ready(() => updateAll());

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((node) => {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches(".attachement")) updateAttachment(node);
        else updateAll(node);
      });
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener("change", (e) => {
    const a = e.target.closest?.(".attachement a[download], .attachement a[href]");
    if (a) updateAttachment(a.closest(".attachement"));
  });
})();
//#endregion
(() => {
  let areaCounter = 0; // Contatore per le aree
  let taskCounters = {}; // Contatori per i task per ogni area
  let currentTaskTarget = null; // Per sapere su quale task applicare note/segnalazioni/cambio operatore

  document.addEventListener("DOMContentLoaded", () => {
    const areaForm = document.querySelector("#modal-add-area form");
    const areaSelect = document.querySelector("#add-area-referente");
    const areaContainer = document.querySelector(".area");

    const taskForm = document.querySelector("#modal-add-task form");
    const taskOperatore = document.querySelector("#add-task-operatore");
    const taskTitle = document.querySelector("#add-task-title");
    const taskDesc = document.querySelector("#add-task-dec");

    const notesForm = document.querySelector("#modal-add-notes form");
    const noteInput = document.querySelector("#add-note");

    const segnalazioneForm = document.querySelector("#modal-add-segnalazione form");
    const segnalazioneInput = document.querySelector("#add-segnalazione");

    const changeOpForm = document.querySelector("#modal-change-operator form");
    const changeOpSelect = document.querySelector("#change-operatore");

    // 🔹 Utility: chiudi modale in sicurezza evitando aria-hidden focus bug
    const closeModal = (modalId) => {
      const modalEl = document.getElementById(modalId);
      if (!modalEl) return;
      const modal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
      modal.hide();
    };

    // ==================================================
    // GESTIONE AREE
    // ==================================================
    areaForm.addEventListener("submit", (e) => {
      closeModal("modal-add-area");
    });

    // ==================================================
    // GESTIONE TASK
    // ==================================================
    taskForm.addEventListener("submit", (e) => {
      taskOperatore.value = "";
      taskTitle.value = "";
      taskDesc.value = "";
      closeModal("modal-add-task");
    });

    // intercetta click su btn "Aggiungi un Task" per capire area corrente
      document.body.addEventListener("click", (e) => {
          if (e.target.closest(".add-task-btn")) {

              const btn = e.target.closest(".add-task-btn");
              const currentCategoryId = btn.dataset.areacategoryid;

              const userSelect = document.getElementById("UserId");
              const options = userSelect.querySelectorAll("option");

              // ⭐ RESET COMPLETO DELLO STATO
              userSelect.value = "";                   // svuota selezione
              options.forEach(option => option.hidden = false); // mostra tutti gli option

              // aggiorno i campi nascosti
              taskForm.dataset.area = btn.dataset.area;
              document.getElementById("CurrentAreaId").value = btn.dataset.areaid;
              document.getElementById("CurrentAreaCategoryId").value = btn.dataset.areacategoryid;

              // ⭐ APPLICO IL NUOVO FILTRO
              options.forEach(option => {
                  const optionCategory = option.getAttribute("data-category");

                  if (option.value === "") {
                      option.hidden = false; // l'option vuoto resta visibile
                      return;
                  }

                  if (optionCategory !== currentCategoryId) {
                      option.hidden = true;
                  } else {
                      option.hidden = false;
                  }
              });
          }

    });

    // ==================================================
    // INTERVENTO COMPLETATO / RIAPRI
    // ==================================================
    document.body.addEventListener("click", (e) => {
      const area = e.target.closest(".area__item");
      if (!area) return;

      // CHIUDI
      if (e.target.closest(".close-area")) {
        const checkboxes = area.querySelectorAll(".form-check-input");
        checkboxes.forEach((cb) => {
          cb.checked = true;
          cb.disabled = true;
        });
        const buttons = area.querySelectorAll(".accordion-button");
        buttons.forEach((btn) => btn.classList.add("text-dark"));
        const actions = area.querySelectorAll(".task-action");
        actions.forEach((act) => act.classList.add("d-none"));

        area.querySelector(".close-area").classList.add("d-none");
        area.querySelector(".add-task-btn").classList.add("d-none");
        area.querySelector(".reopen-task").classList.remove("d-none");
      }

        // RIAPRI
      if (e.target.classList.contains("reopen-task")) {
        e.preventDefault();
        const checkboxes = area.querySelectorAll(".form-check-input");
        checkboxes.forEach((cb) => {
          cb.disabled = false;
        });
        const buttons = area.querySelectorAll(".accordion-button");
        buttons.forEach((btn) => btn.classList.remove("text-dark"));
        const actions = area.querySelectorAll(".task-action");
        actions.forEach((act) => act.classList.remove("d-none"));

        area.querySelector(".close-area").classList.remove("d-none");
        area.querySelector(".add-task-btn").classList.remove("d-none");
        area.querySelector(".reopen-task").classList.add("d-none");
      }
    });
  });
})();
(() => {
    function infoWindow(type, title, message) {
        Swal.fire({
            title: title,
            text: message,
            icon: type,
            timer: 3000,
            showConfirmButton: false
        });
    }
    window.infoWindow = infoWindow;

    async function toggleTask(taskId, completed, checkboxEl, startOrComplete) {
        if (startOrComplete == "start") {
            try {
                const apiBase = `${window.APP_BASE_URL}api`;
                const response = await fetch(`${apiBase}/Ticket/StartTask`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ EntityId: taskId, Started: completed })
                });
                if (!response.ok) throw new Error('Errore server');
                const data = await response.json();
                if (data.success) {
                    updateDateSpan(checkboxEl, completed);
                    infoWindow("success", "Aggiornamento completato", completed ? 'Task preso in carico' : 'Task segnato come da prendere in carico');
                }
            } catch (err) {
                infoWindow("error", "Errore", "Impossibile aggiornare");
            }
        } else {
            try {
                
                const apiBase = `${window.APP_BASE_URL}api`;
                const response = await fetch(`${apiBase}/Ticket/ToggleTask`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ EntityId: taskId, Completed: completed })
                });
                if (!response.ok) throw new Error('Errore server');
                const data = await response.json();
                if (data.success) {
                    updateDateSpan(checkboxEl, completed);
                    infoWindow("success", "Aggiornamento completato", completed ? 'Task completato' : 'Task segnato come incompleto');
                }
            } catch (err) {
                infoWindow("error", "Errore", "Impossibile aggiornare");
            }
        }
    }


    // Aggiorna lo span data partendo dal checkbox element diretto — zero ambiguità
    function updateDateSpan(checkboxEl, show) {
        // Sali al .form-check (il contenitore con flex-column)
        const formCheck = checkboxEl.closest('.form-check');
        if (!formCheck) return;

        // Lo span della data è figlio diretto di .form-check, non del div interno
        let dateSpan = formCheck.querySelector(':scope > span.text-muted');
        if (show) {
            if (!dateSpan) {
                dateSpan = document.createElement('span');
                dateSpan.className = 'text-muted';
                dateSpan.style.fontSize = '0.75rem';
                formCheck.appendChild(dateSpan);
            }
            dateSpan.textContent = formatDateNow();
        } else {
            if (dateSpan) dateSpan.remove();
        }
    }

    function formatDateNow() {
        const now = new Date();
        const dd = String(now.getDate()).padStart(2, '0');
        const mm = String(now.getMonth() + 1).padStart(2, '0');
        const yyyy = now.getFullYear();
        const HH = String(now.getHours()).padStart(2, '0');
        const min = String(now.getMinutes()).padStart(2, '0');
        return `${dd}/${mm}/${yyyy} ${HH}:${min}`;
    }

    window.toggleTask = toggleTask;

    async function startTask(taskId, started) {
        try {
            const apiBase = `${window.APP_BASE_URL}api`;
            const response = await fetch(`${apiBase}/Ticket/StartTask`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    EntityId: taskId,
                    Started: started
                })
            });
            if (!response.ok) throw new Error('Errore server');
            const data = await response.json();
            if (data.success) {
                infoWindow("success", "Aggiornamento completato", started ? 'Task iniziato' : 'Task segnato come da prendere in carico')
            }
        } catch (err) {
            infoWindow("error", "Errore", "Impossibile aggiornare")
        }
    }
    window.startTask = startTask;

    async function closeArea(areaId, completed) {
        try {
            const apiBase = `${window.APP_BASE_URL}api`;
            const response = await fetch(`${apiBase}/Ticket/ToggleArea`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    EntityId: areaId,
                    Completed: completed
                })
            });
            if (!response.ok) throw new Error('Errore server');
            const data = await response.json();
            if (data.success) {
                infoWindow("success", "Aggiornamento completato", completed ? 'Area completata' : 'Area segnata come incompleta')
                if (completed) {
                    $('.close-area[area-id="' + areaId + '"]').addClass("d-none");
                    $('.add-task-btn[areaid="' + areaId + '"]').addClass("d-none");
                } else {
                    $('.close-area[area-id="' + areaId + '"]').removeClass("d-none");
                    $('.add-task-btn[areaid="' + areaId + '"]').removeClass("d-none");
                }
            }
        } catch (err) {
            infoWindow("error", "Errore", "Impossibile aggiornare")
        }
    }

    window.closeArea = closeArea;
})();
//#endregion
